// src/components/ModalSeleccionCasa.js
import React, { useState } from 'react';
import { FaHome, FaCheckCircle, FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';
import './ModalSeleccionCasa.css';

const ModalSeleccionCasa = ({ isOpen, casas = [], onSelectCasa }) => {
    const [selectedId, setSelectedId] = useState(() => casas[0]?.id || '');

    if (!isOpen || !Array.isArray(casas) || casas.length <= 1) return null;

    const currentSelectedId = selectedId || casas[0]?.id;

    const handleConfirm = () => {
        if (currentSelectedId && onSelectCasa) {
            onSelectCasa(currentSelectedId);
        }
    };

    const getCasaLabel = (casa) => {
        const partes = [];
        if (casa.calle) partes.push(casa.calle);
        if (casa.numero || casa.numeroExterior) partes.push(`No. ${casa.numero || casa.numeroExterior}`);
        if (casa.manzana) partes.push(`Mza ${casa.manzana}`);
        if (casa.lote) partes.push(`Lote ${casa.lote}`);
        return partes.length > 0 ? partes.join(', ') : `Propiedad ${casa.id}`;
    };

    return (
        <div className="modal-casa-overlay">
            <div className="modal-casa-card glass-container">
                <div className="modal-casa-header">
                    <div className="modal-badge-house">
                        <FaHome />
                        <span>Propiedades Registradas</span>
                    </div>
                    <h2>Selecciona tu Propiedad</h2>
                    <p>Posees múltiples casas en este fraccionamiento. Elige la propiedad que deseas consultar:</p>
                </div>

                <div className="modal-casa-body">
                    <div className="casas-cards-grid">
                        {casas.map((item) => {
                            const isSelected = currentSelectedId === item.id;
                            const label = getCasaLabel(item);
                            const adeudo = typeof item.adeudo === 'number' ? item.adeudo : (item.saldoPendiente || 0);

                            return (
                                <div
                                    key={item.id}
                                    className={`casa-card-option ${isSelected ? 'selected' : ''}`}
                                    onClick={() => setSelectedId(item.id)}
                                >
                                    <div className="casa-card-icon">
                                        <FaHome className="home-icon" />
                                    </div>
                                    <div className="casa-card-info">
                                        <h3>{label}</h3>
                                        <span className={`casa-card-saldo ${adeudo > 0 ? 'con-adeudo' : 'al-dia'}`}>
                                            <FaMapMarkerAlt /> {adeudo > 0 ? `Adeudo: $${adeudo.toFixed(2)}` : 'Al día / Al corriente'}
                                        </span>
                                    </div>
                                    <div className="casa-card-check">
                                        {isSelected && <FaCheckCircle className="check-icon" />}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="modal-casa-footer">
                    <button
                        type="button"
                        className="btn-confirm-casa"
                        disabled={!currentSelectedId}
                        onClick={handleConfirm}
                    >
                        <span>Consultar esta Propiedad</span>
                        <FaArrowRight />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalSeleccionCasa;
